import React from 'react';

import {useSelector} from 'react-redux';
import AppMessageView from '@crema/core/AppMessageView';
import AppLoader from '@crema/core/AppLoader';

const AppInfoView = () => {
  const {error, loading, message, warning} = useSelector(({common}) => common);

  const showMessage = () => {
    return <AppMessageView variant='success' message={message.toString()} />;
  };

  const showWarning = () => {
    return <AppMessageView variant='warning' message={warning.toString()} />;
  }

  const showError = () => {
    return <AppMessageView variant='error' message={error.toString()} />;
  };

  return (
    <>
      {loading && <AppLoader />}
      {warning && showWarning()}
      {message && showMessage()}
      {error && showError()}
    </>
  );
};

export default AppInfoView;
